import React from "react";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

const UploadThubmnail = ({
  previewUrl,
  setPreviewUrl,
  setFile,
  hasHeading,
  disabled,
}: {
  hasHeading?: boolean;
  previewUrl: string;
  setPreviewUrl: React.Dispatch<React.SetStateAction<string>>;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
  disabled?: boolean;
}) => {
  const theme = useTheme();

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFile(file);
        setPreviewUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveCoverPicture = () => {
    setFile(null);
    setPreviewUrl("");
  };

  return (
    <>
      {hasHeading && (
        <Typography sx={{ marginBottom: 1 }}>
          Upload Thumbnail{" "}
          <span style={{ color: theme.palette.text.secondary }}>*</span>
        </Typography>
      )}

      {previewUrl ? (
        <Box
          sx={{
            position: "relative",
            width: 155,
            height: 90,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={previewUrl}
            width={150}
            height={85}
            alt="Preview"
            style={{
              objectFit: "cover",
            }}
          />
          {!disabled && (
            <IconButton
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                padding: 0.5,
              }}
              onClick={handleRemoveCoverPicture}
            >
              <CancelIcon
                sx={{
                  color: "gray",
                  backgroundColor: "white",
                  borderRadius: "50%",
                  fontSize: 15,
                }}
              />
            </IconButton>
          )}
        </Box>
      ) : (
        <>
          <input
            type="file"
            accept="image/jpeg, image/jpg, image/png"
            onChange={handleFileInputChange}
            disabled={disabled}
            style={{ display: "none", height: 90, border: "1px solid blue" }}
            id="thumbnail-upload"
          />
          <label htmlFor="thumbnail-upload">
            <Box
              component="div"
              sx={{
                border: `1px dashed ${theme.palette.primary.main}`,
                borderRadius: theme.shape.borderRadius,
                padding: theme.spacing(2),
                cursor: "pointer",
                height: 90,
              }}
            >
              <Typography sx={{ color: theme.palette.text.disabled }}>
                Upload Thumbnail{" "}
              </Typography>
            </Box>
          </label>
        </>
      )}
    </>
  );
};

export default UploadThubmnail;
